import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Container } from "reactstrap";
import userPlaceholder from "../../assets/images/placeholder.jpg";
import axios from "axios";
import cookie from "js-cookie";
import { toast } from "react-toastify";
import Loader from "../../components/shared/Loader";
import server from "../../api/server";
import {
	useHistory,
	useParams,
} from "react-router-dom/cjs/react-router-dom.min";

const CreateDesign = () => {
	const [loading, setLoading] = useState(false);
	const [previewFile, setPreviewFile] = useState(null);
	const [selectedFile, setSelectedFile] = useState(null);
	const history = useHistory();

	const {
		register,
		getValues,
		setValue,
		formState: { errors },
		handleSubmit,
	} = useForm();

	const isImage = file => {
		if (!file) return false;
		const type = typeof file === "string" ? file : file.type;
		return type?.includes("image");
	};

	const isVideo = file => {
		if (!file) return false;
		const type = typeof file === "string" ? file : file.type;
		return type?.includes("video");
	};

	const handleUpload = async e => {
		const file = e.target.files?.[0];
		if (!file) return;

		setLoading(true);

		setPreviewFile(file);

		setSelectedFile({ name: file.name, size: file.size, type: file.type });
		const formData = new FormData();
		formData.append("file", file);

		try {
			const response = await axios.post(
				`${process.env.REACT_APP_API_URL}/upload`,
				formData,
				{
					headers: {
						Authorization: `Bearer ${cookie.get("token")}`,
						Accept: "application/json",
						"Content-Type": "multipart/form-data",
					},
				}
			);

			const uploadedPath = `${process.env.REACT_APP_MAIN_URL}${response?.data?.data?.file?.path}`;

			if (uploadedPath) {
				setValue("fileUrl", uploadedPath);
				toast.success("تم رفع الملف بنجاح");
			}
		} catch (error) {
			toast.error("خطأ، برجاء المحاولة مره اخرى!");
		} finally {
			setLoading(false);
		}
	};

	const submitHandler = async data => {
		data.title = "design";
		data.file = selectedFile;
		try {
			await server(cookie).post(`/pages/designs/sections`, {
				section: data,
			});
			toast.success("تم الإرسال بنجاح");
			if (selectedFile?.type?.includes("image")) {
				history.push("/designs/images");
			} else {
				history.push("/designs/videos");
			}
		} catch (error) {
			console.log(error);
		}
	};

	return (
		<section>
			{loading && <Loader />}
			<Container>
				<div className="card p-3">
					<form onSubmit={handleSubmit(submitHandler)}>
						<div className="col-xs-12 col-md-6 mx-auto">
							<div className="card-body">
								<div className="form-item mb-3">
									<label htmlFor="picture">التصميم</label>
									<input
										type="file"
										id="picture"
										accept="image/*,video/*"
										{...register("file", {
											required: "برجاء تحميل التصميم",
											onChange: handleUpload,
										})}
									/>
									<div className="mt-3">
										{previewFile || getValues("fileUrl") ? (
											isImage(previewFile || getValues("fileUrl")) ? (
												<img
													src={
														previewFile
															? URL.createObjectURL(previewFile)
															: getValues("fileUrl")
													}
													alt="preview"
													className="imagePreview"
													style={{
														width: "100%",
														maxHeight: "300px",
														objectFit: "contain",
													}}
												/>
											) : isVideo(previewFile || getValues("fileUrl")) ? (
												<video
													controls
													src={
														previewFile
															? URL.createObjectURL(previewFile)
															: getValues("fileUrl")
													}
													className="videoPreview"
													style={{
														width: "100%",
														maxHeight: "300px",
														objectFit: "contain",
													}}
												/>
											) : (
												<p className="text-muted">
													نوع الملف غير مدعوم للمعاينة
												</p>
											)
										) : (
											<img
												src={userPlaceholder}
												alt="placeholder"
												className="imagePreview"
												style={{
													width: "100%",
													maxHeight: "300px",
													objectFit: "contain",
												}}
											/>
										)}
									</div>
									{errors?.file && (
										<p className="text-danger mt-2">{errors.file.message}</p>
									)}
								</div>
								<div className="form-item mt-4">
									<button className="btn btn-success btn-block">ارسال</button>
								</div>
							</div>
						</div>
					</form>
				</div>
			</Container>
		</section>
	);
};

export default CreateDesign;
